import { render } from "./CommentNew.vue?vue&type=template&id=6a7a882c&scoped=true&lang=pug"
import script from "./CommentNew.vue?vue&type=script&lang=js"
export * from "./CommentNew.vue?vue&type=script&lang=js"

import "./CommentNew.vue?vue&type=style&index=0&id=6a7a882c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a7a882c"]])

export default __exports__